import { createSelector } from "reselect"
import { find, get } from "lodash"
import { getCategories } from "selectors/factors"
import { getCurrent, getFirst } from "./risk"
import { getDisplayCategories } from "./data"
import { getDisplayType } from "./items"
import { ATTRIBUTION_COLORS } from "helpers/analyzeConstants"

export const getOptions = createSelector(
  [getCategories, getFirst, getCurrent, getDisplayCategories],
  (categories, first, current, displayCategories) => {
    if (first && current) {
      const options = [{
        id: "total",
        color: ATTRIBUTION_COLORS.TOTAL,
        label: "Total",
        value: current.total,
        firstValue: first.total,
        delta: (current.total - first.total),
      }, {
        id: "factors",
        color: ATTRIBUTION_COLORS.FACTOR,
        label: "Factors",
        value: current.factorsTotal,
        firstValue: first.factorsTotal,
        delta: (current.factorsTotal - first.factorsTotal),
      },
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (displayCategories.indexOf(category.id) === -1) return null

          const field = `categories.${category.id}`
          const value = get(current, field, 0)
          const firstValue = get(first, field, 0)
          const delta = value - firstValue

          return { value, delta, firstValue, ...category }
        }),
      ]

      // filter out options for which there's no value
      return options.filter(option => option && !Number.isNaN(option.value))
    } else {
      return []
    }
  },
)

export const getSelectedOption = createSelector(
  [getOptions, getDisplayType],
  (options, displayType) => {
    return find(options, { id: displayType })
  },
)
